import { useRegisterSW } from "virtual:pwa-register/react";

/**
 * Registers the service worker (registerType: autoUpdate — the SW itself
 * activates new versions automatically on next navigation) and surfaces a
 * subtle, dismissible banner when a new build has been fetched so the user
 * can refresh immediately instead of waiting for the next tab reopen.
 *
 * Mount once near the app root (see main.tsx).
 */
export function UpdateToast() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      // Poll for a fresh sw.js periodically so long-lived open tabs still
      // notice a deploy without a full page navigation.
      if (!registration) return;
      const HOUR = 60 * 60 * 1000;
      setInterval(() => {
        registration.update().catch(() => {
          /* offline or navigation in flight — ignore */
        });
      }, HOUR);
      void swUrl;
    },
  });

  if (!needRefresh) return null;

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 rounded-lg border border-copper/40 bg-bg-card px-4 py-3 shadow-lg"
      role="status"
      aria-live="polite"
    >
      <span className="text-sm text-text-primary">Update available</span>
      <button
        type="button"
        onClick={() => updateServiceWorker(true)}
        className="px-3 py-1.5 rounded-md text-sm font-medium bg-copper text-white hover:bg-copper-hover transition-colors"
      >
        Refresh
      </button>
      <button
        type="button"
        onClick={() => setNeedRefresh(false)}
        className="p-1 rounded text-text-muted hover:text-text-primary transition-colors"
        aria-label="Dismiss"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
